<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M19.5 2.5h-15v9C4.5 15 9.308 16 12 16s7.5-1.583 7.5-4.5v-9zM22.5 7a2 2 0 01-2 2h-1V4h1a2 2 0 012 2v1zM1.5 6a2 2 0 012-2h1v5h-1a2 2 0 01-2-2V6zM12 16v2M16.5 18.5h-9v3h9v-3z"/>
</svg>
